import { Component, AfterViewInit, ElementRef, Input, OnInit, OnChanges, ViewChild, SimpleChanges } from '@angular/core';

import { ApiError, AuthService, BaseFilterCollapse, BaseFilterCollapseService, MessageService } from '../../../core';
import { RegiaoFilter } from './regiao-filter';
import { Representante } from '../../pessoa/representante';
import { Estado, EstadoCrudHttpService } from '../../estado';

@Component({
    selector: 'sgt-regiao-filter-collapse',
    templateUrl: './regiao-filter-collapse.component.html',
    styleUrls: ['./regiao-filter-collapse.component.less']
})
export class RegiaoFilterCollapseComponent implements BaseFilterCollapse, OnInit, OnChanges, AfterViewInit {
    @Input() isCollapsedInDefault = false;
    isCollapsedIn = false;
    @ViewChild('filterCollapse') filterCollapse: ElementRef;
    collapseIcon = 'fas fa-caret-down';
    isFilterDirty = false;


    @Input() filter: RegiaoFilter;
    isRepresentante: boolean;
    estados: Estado[] = [];

    constructor(private authService: AuthService,
                private messageService: MessageService,
                private baseFilterCollapseService: BaseFilterCollapseService,
                private estadoCrudHttpService: EstadoCrudHttpService) { }

    ngOnInit() {
        this.isRepresentante = this.authService.isRepresentante();
        this.searchEstados();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'isCollapsedInDefault') {
                if (changes[propName].isFirstChange) {
                    setTimeout(() => {
                        this.isCollapsedIn = changes[propName].currentValue;
                    }, 100);
                }
            }
        }
    }

    ngAfterViewInit() {
      if (!this.isCollapsedInDefault) {
        jQuery(this.filterCollapse.nativeElement).css('display', 'none');
      }
    }

    /** Abre/Fecha o filtro */
    toggleCollapse() {
        this.baseFilterCollapseService.toggleCollapse(this);
    }

    /** Abre o filtro */
    open() {
        this.baseFilterCollapseService.open(this);
    }

    /** Fecha o filtro */
    close() {
        this.baseFilterCollapseService.close(this);
    }

    /** Limpa o filtro */
    clear() {
        this.baseFilterCollapseService.clear(this);
    }

    /** Pesquisa todos os estados */
    private searchEstados() {
        this.estadoCrudHttpService.search()
            .subscribe(
                entities => this.estados = entities,
                (error: ApiError) => this.messageService.error(error.message,  'Erro ao pesquisar os estados para o filtro do cliente', error)
            );
    }

    /** Ao alterar o representante no typeahead */
    onTypeaheadChangeRepresentante(representante: Representante) {
        if (representante) {
            this.filter.idRepresentante = representante.id;
            this.isFilterDirty = true;
        } else {
            this.filter.idRepresentante = null;
        }
    }
}
